module.exports = __webpack_public_path__ + "static/media/wizard-welcome.6d7a36e9.png";